import { useTranslation } from '@sib/i18n';
import { Button } from '@sib/ui';
import { UseRemoveAccessDialogReturn } from '../use-remove-access-dialog';

interface ConfirmDeleteViewProps {
  removeAccessDialog: UseRemoveAccessDialogReturn;
}

export const ConfirmDeleteView = ({
  removeAccessDialog,
}: ConfirmDeleteViewProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-7">
      <h3 className="text-primary text-xl leading-7 font-semibold">
        {t('components.shareDialog.removeAccess.confirmation.title')}
      </h3>
      <p className="text-primary text-sm">
        {t('components.shareDialog.removeAccess.confirmation.description', {
          name: removeAccessDialog.invitee?.name,
        })}
      </p>
      <div className="flex justify-center gap-4">
        <Button
          disabled={removeAccessDialog.loading}
          variant="outline"
          onClick={removeAccessDialog.onClose}
        >
          {t('cancel')}
        </Button>
        <Button
          loading={removeAccessDialog.loading}
          onClick={removeAccessDialog.onConfirm}
        >
          {t('components.shareDialog.remove')}
        </Button>
      </div>
    </div>
  );
};
